import * as React from 'react'
import PropTypes from 'prop-types'
import * as providers from 'utils/providers'

function AuthSocialButton(props) {
  const { appId, component: Component = 'div', onError, onSuccess, provider, ...other } = props

  const handleClick = React.useCallback(async () => {
    try {
      const result = await providers[provider].login()

      onSuccess(result, provider)
    } catch (error) {
      onError(error)
    }
  }, [provider, onError, onSuccess])

  React.useEffect(() => {
    if (providers[provider] && providers[provider].load) {
      providers[provider].load({ appId })
    }
  }, [appId, handleClick, provider])

  return <Component onClick={handleClick} {...other} />
}
AuthSocialButton.propTypes = {
  appId: PropTypes.string,
  component: PropTypes.elementType,
  onError: PropTypes.func,
  onSuccess: PropTypes.func,
  provider: PropTypes.string,
}

export default AuthSocialButton
